module.exports = __webpack_public_path__ + "static/media/profilePic.29512245.png";